import { render, staticRenderFns } from "./CompanyShares.vue?vue&type=template&id=47d2601c&scoped=true&"
import script from "./CompanyShares.vue?vue&type=script&lang=js&"
export * from "./CompanyShares.vue?vue&type=script&lang=js&"
import style0 from "./CompanyShares.vue?vue&type=style&index=0&id=47d2601c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d2601c",
  null
  
)

export default component.exports